import React from 'react';
import SolutionInstallmentExaminationChoiceWrapper from 'components/SolutionInstallmentExaminationChoiceWrapper/SolutionInstallmentExaminationChoiceWrapper';

export default function SolutionInstallmentExaminationChoiceContainer() {
    return (
        <SolutionInstallmentExaminationChoiceWrapper />
    )
}
